import React from 'react';
import { IonCol } from '@ionic/react';
import './CategoryGrid.scss';
import { baseUrl, cacheBust } from '../helpers/configHelper';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../store';

interface CategoryGridProps {
    categoryId: number;
    categoryImage: string;
    categoryName: string;
    fullWidth: boolean;
    onClick?: (categoryId: number) => void;
    isFavourites?: boolean;
    sortOrder?: number;
}

const CategoryGrid: React.FC<CategoryGridProps> = ({
    categoryId,
    categoryImage,
    categoryName,
    fullWidth,
    onClick,
    isFavourites,
    sortOrder,
}) => {
    const headerState = useSelector((state: ApplicationState) => state.headerFooter);

    return (
        <IonCol
            key={"KY" + categoryId}
            onClick={() => onClick && onClick(categoryId)}
            size={fullWidth ? "12" : "6"}
            className="category-column"
        >
            {isFavourites
                ?
                <div>
                    <div className="favourites">
                        <img
                            className="favourites-card"
                            alt={`category_image_favourites`}
                            src={`${baseUrl()}/images/CategoryShots/Favourites.png?v=${cacheBust()}`}
                        />
                        <div className="favourites-label">
                            <p className="title">Your Caf&eacute; <span className="bold">favourites</span></p>
                            <p>Quick access to Caf&eacute; favourites you've ordered before.</p>
                        </div>
                    </div>
                </div>
                :
                <div>
                    <img
                        alt={`category_image_${categoryId}`}
                        src={(fullWidth
                            ? `${baseUrl()}/images/CategoryShots/` + categoryImage + '_fw.jpg'
                            : `${baseUrl()}/images/CategoryShots/` + categoryImage) + `?v=${cacheBust()}`
                        }
                    />
                </div>
            }
        </IonCol>
    );
};

export default CategoryGrid;
